/* eslint-disable @typescript-eslint/ban-types */
import React, { createContext, useCallback, useContext, useState } from 'react';


interface RouteContextData {
  routeActive: string;
  setRouteActive(route: string): void;

}

const RouteContext = createContext<RouteContextData>({} as RouteContextData);



export const RouteProvider: React.FC = ({children}) => {



  const [data, setData] = useState('register-user');


  const setRouteActive = useCallback((route: string) => {
       setData(route);
  }, []);



  return (
    <RouteContext.Provider value={{ routeActive: data, setRouteActive }}>
      {children}
    </RouteContext.Provider>
  );
};

export function useRoute(): RouteContextData {
  const context = useContext(RouteContext);
  return context;
}
